import React, {Component} from 'react'
import AuthComponent from "../SharedComponents/AuthComponent";
import UpdatedLandingPageIndex from "../LandingPage/UpdatedLandingPageIndex";
import TeamsIDDisplay from "./TeamsIDDisplay"

class TeamsIDIndex extends Component {
    render() {
        return (
            <div>
                <AuthComponent
                    authComponent={<TeamsIDDisplay />}
                    nonAuthComponent={<UpdatedLandingPageIndex/>}
                />
            </div>
        )
    }
}

export default TeamsIDIndex